import { Header } from '@/components/Header';
import { ChatPanel } from '@/components/ChatPanel';
import { FileManager } from '@/components/FileManager';
import { PreviewPanel } from '@/components/PreviewPanel';

const Index = () => {
  return (
    <div className="flex flex-col h-screen">
      <Header />
      <div className="flex-1 flex overflow-hidden">
        <div className="flex-1 flex">
          <div className="w-96 flex flex-col border-r border-border">
            <div className="flex-1 overflow-hidden">
              <ChatPanel />
            </div>
          </div>
          <div className="flex-1 flex">
            <FileManager />
            <div className="resizer" />
            <PreviewPanel />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;